import comp from "./EventHeader";
export default comp;
